var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlatform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 74,
    viewBox: "0 0 92 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6078 24.848L52.5703 12.18C53.9071 11.7865 55.2975 12.4908 55.7691 13.8184L74.8975 74.3089C75.291 75.6365 74.5836 77.03 73.259 77.5046L54.4936 83.452L33.2842 90.1727C31.9597 90.5662 30.5708 89.8618 30.0854 88.5342L10.9816 28.0284C10.5099 26.7008 11.297 25.2247 12.6078 24.848Z",
    fill: "white",
    stroke: "#393B46",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4995 15.1946V12.6374C24.4995 10.0649 26.5973 7.90125 29.1668 7.90125L43.5437 8.63625C44.0306 8.66075 44.5191 8.66228 45.0075 8.64084L66.7299 7.65625C69.3131 7.65625 71.4767 9.75406 71.4767 12.3266L70.7448 19.1896C69.9547 26.5932 70.1476 34.0703 71.319 41.4234L71.6988 43.8106",
    stroke: "#393B46",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7974 33.6643C28.228 37.8599 28.228 43.0708 30.7974 47.2664C32.8953 50.381 36.6315 52.0852 40.2897 52.8708C44.3413 53.641 52.849 54.3729 56.0217 51.8004C60.0734 48.3092 57.7138 41.6773 56.0753 36.5476C52.5887 26.1918 36.6315 24.4875 30.7974 33.6643Z",
    fill: "#FA532E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5282 33.3217C24.9587 37.5173 24.9587 42.7281 27.5282 46.9238C29.626 50.0383 33.3622 51.7426 37.0204 52.5281C41.0721 53.2984 45.6612 52.9217 48.834 50.3492C52.8857 46.8579 54.446 41.3347 52.806 36.205C49.3178 25.8476 33.3622 24.1434 27.5282 33.3217Z",
    stroke: "#393B46",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9917 67.7528C42.1471 65.802 50.3929 64.0977 58.5484 62.1484",
    stroke: "#393B46",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.489 79.7333C46.6567 77.1608 54.8121 74.2928 62.9798 71.7188",
    stroke: "#393B46",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlatform);
export default __webpack_public_path__ + "static/media/icon-platform.a7b62094b04a9dba11f9b905e3c0044f.svg";
export { ForwardRef as ReactComponent };